<fieldset class="{{#if disabled}}disabled{{/if}}"{{#if disabled}}disabled{{/if}}>
  <legend class="{{legend_class}} radio-legend">{{t legend}}</legend>
    {{#if header}}
      <div class="header {{header_class}}">{{t header}}</div>
    {{/if}}
    {{#if (equal helptext.position 'top')}}
      <p class="helptext"><small>{{t helptext.text}}</small></p>
    {{/if}}
  <div class="label-wrapper">
    {{#each options}}
      {{#if label}}
        <input id="{{id}}" type="radio" name="{{../name}}" value="{{value}}" {{#if default_value}}checked{{/if}} {{#if attributes}}data-attributable{{/if}} />
          <label for="{{id}}" class="{{option_class}} {{#if default_value}}checked{{/if}} {{#if attributes.disabled}}disabled{{/if}}"><span class="input"></span>
              {{#if img_path}}
              <img
                class="label-img"
                src="{{assetPath img_path}}"
                id="{{img_id}}"
                alt="{{t img_description}}"
                {{#if srcset}}srcset="{{srcset}}"{{/if}}
                {{#if sizes}}sizes="{{sizes}}"{{/if}}
                />
              {{/if}}

              {{#if icon_class}}
                <span aria-hidden="true" class="{{icon_class}} {{icon_size}}" {{#if sr_caption}} title="{{sr_caption}}" {{/if}}></span>
                {{#if sr_caption}}<span class="screen-reader-content">{{t sr_caption}}</span>{{/if}}
              {{/if}}
              <div class="text-wrapper">
                <span class="label-text {{../label_class}}">{{t label}}</span>
                {{#if description}}
                  <div class="description-text {{../description_class}}">{{t description}}</div>
                {{/if}}
              </div>
          </label>
      {{else}}
          <input type="radio" class="{{option_class}}" name="{{../name}}" value="{{value}}" {{#if default_value}}checked{{/if}} {{#if attributes}}data-attributable{{/if}} />
      {{/if}}
    {{/each}}
    {{#if (equal helptext.position 'bottom')}}
      <p class="helptext"><small>{{t helptext.text}}</small></p>
    {{/if}}
  </div>
</fieldset>